const baseUrl = "https://feiniao-media-receiving.sysuimars.cn/site/";

export default {
    receive: {
        url: baseUrl + "sk_oss_receive",
        type: "post",
    },
};
